import React, { useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import './WhatWeDo.css';

const sections = [
  {
    id: 'adaptive',
    title: 'Adaptive Clothing',
    copy:
      'Magnetic and Velcro fastenings, flat seams, and easy closures that make dressing simpler for every body. Built for independence without losing style.',
    image: '/assets/products/01-tsu-side-opening-pants.jpg',
  },
  {
    id: 'sensory',
    title: 'Sensory Clothing',
    copy:
      'Tag-free, soft-touch fabrics with minimal seams and no hard trims. Designed to feel calm, breathable, and irritation-free all day.',
    image: '/assets/products/01-tsu-comfy-tshirt_595b0f46-57f4-40b0-b7f6-205c3c6e10bf.jpg',
  },
  {
    id: 'custom',
    title: 'Custom Made',
    copy:
      'Made-to-order adjustments for unique needs, from fit tweaks to adaptive features. We work with you to create clothing that feels right.',
    image: '/assets/products/01-tsu-comfy-polo-shirt_109ecd3c-4030-4d5c-ad86-2082dba33448.jpg',
  },
  {
    id: 'research',
    title: 'Research',
    copy:
      'We collaborate with clinicians, carers, and customers to keep improving adaptive and sensory design. Every collection is informed by real-world feedback.',
    image: '/assets/products/01-tsu-boat-neck-short-sleeve-top_0f018091-75bc-4b87-a896-f9f2a5ddfeca.jpg',
  },
];

const WhatWeDo = () => {
  const { section } = useParams();
  const location = useLocation();

  useEffect(() => {
    const target = section || (location.hash || '').replace('#', '');
    if (target) {
      const el = document.getElementById(target);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [section, location.hash]);

  const selectedSection = sections.find((s) => s.id === section);
  const isDetail = Boolean(selectedSection);

  return (
    <div className="what-page">
      <section className="what-hero">
        <p className="eyebrow">Inclusive by design</p>
        <h1>{isDetail ? selectedSection.title : 'What We Do'}</h1>
        <p>
          The Shapes United makes adaptive, sensory-friendly, and custom
          solutions that help people dress with ease and confidence. Explore
          the workstreams that shape every collection.
        </p>
        {isDetail && (
          <Link className="ghost-link back-link" to="/what">
            ← Back to all
          </Link>
        )}
      </section>

      {isDetail ? (
        <section className="what-detail">
          <div className="detail-image">
            <img src={selectedSection.image} alt={selectedSection.title} />
          </div>
          <div className="detail-body">
            <p className="eyebrow">Focus</p>
            <h2>{selectedSection.title}</h2>
            <p className="card-copy">{selectedSection.copy}</p>
            <div className="cta-actions">
              <a className="primary-link" href="/contact">
                Talk to the team
              </a>
              <a className="ghost-link" href="/catalogues">
                View catalogues
              </a>
            </div>
          </div>
        </section>
      ) : (
        <section className="what-grid">
          {sections.map((item) => (
            <Link key={item.id} to={`/what/${item.id}`} className="what-card">
              <div className="card-image">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="card-heading">
                <p className="eyebrow">Focus</p>
                <h2>{item.title}</h2>
              </div>
              <p className="card-copy">{item.copy}</p>
              <div className="card-foot">
                <span className="link-arrow">→</span>
                <span className="card-label">Open section</span>
              </div>
            </Link>
          ))}
        </section>
      )}

      <section className="what-cta">
        <h3>Partner with us</h3>
        <p>
          Working on accessibility, health, or education projects? We collaborate
          with therapists, carers, schools, and brands to deliver adaptive and
          sensory-friendly solutions.
        </p>
        <div className="cta-actions">
          <a className="primary-link" href="/contact">
            Talk to the team
          </a>
          <a className="ghost-link" href="/catalogues">
            View catalogues
          </a>
        </div>
      </section>
    </div>
  );
};

export default WhatWeDo;
